module.exports = __webpack_public_path__ + "03_very_short_brown.a764b9d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer5/03_very_short_brown.png
// module id = S12y
// module chunks = 0